import React from 'react';
import { useLocation } from 'react-router-dom';
import SearchResult from '../SearchResult/SearchResult';


const TesterInterface = () => {
  const location = useLocation();
  const { username } = location.state || {}; // Destructure the username from location.state

  return (
    <div>
  
      <SearchResult />
      {/* <SearchResultQuick/> */}
    </div>
  );
};

export default TesterInterface;
